import { render, staticRenderFns } from "./fqfl.vue?vue&type=template&id=0ca57bf6&scoped=true&"
import script from "./fqfl.vue?vue&type=script&lang=js&"
export * from "./fqfl.vue?vue&type=script&lang=js&"
import style0 from "./fqfl.vue?vue&type=style&index=0&id=0ca57bf6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca57bf6",
  null
  
)

export default component.exports